const Input = {
  defaultProps: {
    errorBorderColor: "error.500",
    focusBorderColor: "primary.500"
  }
};

export default Input;